module.exports = __webpack_public_path__ + "static/media/icon-logout-actived.5e5d0823.svg";